import { render } from "./history_button.vue?vue&type=template&id=2cda1529&scoped=true"
import script from "./history_button.vue?vue&type=script&lang=js"
export * from "./history_button.vue?vue&type=script&lang=js"

import "./history_button.vue?vue&type=style&index=0&id=2cda1529&lang=scss&scoped=true"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cda1529"]])

export default __exports__